import styled from 'styled-components'

const TwitterTweetButtonWrapperUi = styled.div`
  display: flex;
  flex-direction: column;
`

export default TwitterTweetButtonWrapperUi
